import { render, staticRenderFns } from "./Post_Section_Header.vue?vue&type=template&id=839d4b30&scoped=true&"
import script from "./Post_Section_Header.vue?vue&type=script&lang=js&"
export * from "./Post_Section_Header.vue?vue&type=script&lang=js&"
import style0 from "./Post_Section_Header.vue?vue&type=style&index=0&id=839d4b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839d4b30",
  null
  
)

export default component.exports